import { render, staticRenderFns } from "./BolsaVirtualDeTrabajo.vue?vue&type=template&id=758cea7a&scoped=true"
import script from "./BolsaVirtualDeTrabajo.vue?vue&type=script&lang=js"
export * from "./BolsaVirtualDeTrabajo.vue?vue&type=script&lang=js"
import style0 from "./BolsaVirtualDeTrabajo.vue?vue&type=style&index=0&id=758cea7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758cea7a",
  null
  
)

export default component.exports